import { COLUMN_ADDRESS, COLUMN_BUILDING, COLUMN_DEVICE_DESCRIPTION, COLUMN_DOOR, COLUMN_DOOR_DESCRIPTION, COLUMN_ENABLED, COLUMN_FLOOR, COLUMN_NAME, COLUMN_SITE, COLUMN_TYPE, COLUMN_ZONE } from '../../constants/column-types';
import { FILTER_DEVICE_TYPE, FILTER_DOORS, FILTER_ZONES } from '../../constants/filter-types';
import { TableColumn } from '../table/TableColumn';

const HardwareInstallationReportColumn: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 1,
        sortByName: "devName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME
    },
    {
        heading: "Address",
        accessor: "address",
        isNumeric: false,
        id: 2,
        sortByName: "address",
        active: true,
        translationKey: "address",
        columnId: COLUMN_ADDRESS
    },
    {
        heading: "Device Description",
        accessor: "deviceDescription",
        isNumeric: false,
        id: 3,
        sortByName: "devDesc",
        sortDirection: "asc",
        active: false,
        translationKey: "deviceDescription",
        columnId: COLUMN_DEVICE_DESCRIPTION
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 4,
        sortByName: "type",
        sortDirection: "asc",
       // searchOnName: "typeId",
       // lookupName: "type",
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
        filterId: FILTER_DEVICE_TYPE,
        settingDataName: 'type'
    },
    {
        heading: "Door",
        accessor: "locName",
        isNumeric: false,
        id: 5,
        sortByName: "location.locName",
        sortDirection: "asc",
        active: true,
        searchOnName: "location.id",
        lookupName: "location.locName",
        translationKey: "door",
        columnId: COLUMN_DOOR,
        filterId: FILTER_DOORS,
        settingDataName: 'location'
    },
    {
        heading: "Door Description",
        accessor: "locDescription",
        isNumeric: true,
        id: 6,
        sortByName: "location.locDesc",
        sortDirection: "asc",
        active: false,
        translationKey: "doorDescription",
        columnId: COLUMN_DOOR_DESCRIPTION,
    },
    {
        heading: "Zone",
        accessor: "zoneName",
        isNumeric: false,
        id: 7,
        sortByName: "zone.zoneName",
        sortDirection: "asc",
        active: true,
        searchOnName: "zone.id",
        lookupName: "zone.zoneName",
        translationKey: "zone",
        columnId: COLUMN_ZONE,
        filterId: FILTER_ZONES,
        settingDataName: 'zone'
    },
    {
        heading: "Building",
        accessor: "buildingName",
        isNumeric: false,
        id: 8,
        sortByName: "building.buildingName",
        sortDirection: "asc",
        // searchOnName: "building.buildingName",
        // lookupName: "building.buildingName",
        active: true,
        translationKey: "building",
        columnId: COLUMN_BUILDING,
    },
    {
        heading: "Floor",
        accessor: "floorName",
        isNumeric: false,
        id: 9,
        sortByName: "floor.floorName",
        sortDirection: "asc",
        // searchOnName: "floor.floorName",
        // lookupName: "floor.floorName",
        active: true,
        translationKey: "floor",
        columnId: COLUMN_FLOOR,
    },
    {
        heading: "Site",
        accessor: "siteName",
        isNumeric: false,
        id: 9,
        sortByName: "site.siteName",
        sortDirection: "asc",
        // searchOnName: "site.siteName",
        // lookupName: "site.siteName",
        active: true,
        translationKey: "site",
        columnId: COLUMN_SITE,
    },
    {
        heading: "Enabled",
        accessor: "enabled",
        isNumeric: false,
        id: 10,
        sortByName: "enabled",
        active: false,
        translationKey: "enabled",
        columnId: COLUMN_ENABLED,
    }
];
export default HardwareInstallationReportColumn;
